/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddConsultantNotesCommandResult } from '../../models/add-consultant-notes-command-result';

export interface ApiProjectDailyTaskReportsAddConsultantNotesPatch$Params {
      body?: {
'ProjectDailyTaskReportId'?: string;
'ConsultantNotes'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectDailyTaskReportsAddConsultantNotesPatch(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsAddConsultantNotesPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AddConsultantNotesCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsAddConsultantNotesPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddConsultantNotesCommandResult>;
    })
  );
}

apiProjectDailyTaskReportsAddConsultantNotesPatch.PATH = '/api/ProjectDailyTaskReports/AddConsultantNotes';
